module.exports = __webpack_public_path__ + "static/media/drops.934abcea.png";